import React from 'react';
type Star = {
  cx: number;
  cy: number;
  type: 'dot' | 'diamond';
  size: number;
  opacity: number;
};
const STARS: Star[] = [{
  cx: 60,
  cy: 70,
  type: 'diamond',
  size: 6,
  opacity: 0.5
}, {
  cx: 180,
  cy: 40,
  type: 'dot',
  size: 3,
  opacity: 0.6
}, {
  cx: 320,
  cy: 110,
  type: 'diamond',
  size: 7,
  opacity: 0.7
}, {
  cx: 120,
  cy: 200,
  type: 'dot',
  size: 2.5,
  opacity: 0.5
}, {
  cx: 40,
  cy: 300,
  type: 'diamond',
  size: 5,
  opacity: 0.4
}, {
  cx: 260,
  cy: 260,
  type: 'dot',
  size: 3,
  opacity: 0.6
}, {
  cx: 380,
  cy: 340,
  type: 'diamond',
  size: 6,
  opacity: 0.55
}, {
  cx: 200,
  cy: 360,
  type: 'dot',
  size: 2.5,
  opacity: 0.5
}, {
  cx: 340,
  cy: 200,
  type: 'dot',
  size: 3.5,
  opacity: 0.7
}, {
  cx: 90,
  cy: 130,
  type: 'dot',
  size: 2,
  opacity: 0.45
}];
function Diamond({
  cx,
  cy,
  size,
  opacity
}: Omit<Star, 'type'>) {
  return <path d={`M ${cx} ${cy - size} L ${cx + size} ${cy} L ${cx} ${cy + size} L ${cx - size} ${cy} Z`} fill="#f8a400" opacity={opacity} data-id="element-34" />;
}
export function SpaceScene({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 440 560" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} role="img" aria-label="Illustration d'un astronaute flottant au-dessus d'une planète" data-id="element-35">
      {/* Stars */}
      {STARS.map((s, i) => s.type === 'diamond' ? <g key={i} className="animate-pulse" style={{
      animationDelay: `${i * 0.3}s`,
      animationDuration: '3s'
    }} data-id="element-36">
            <Diamond cx={s.cx} cy={s.cy} size={s.size} opacity={s.opacity} data-id="element-37" />
          </g> : <circle key={i} cx={s.cx} cy={s.cy} r={s.size} fill="#ffffff" opacity={s.opacity} className="animate-pulse" style={{
      animationDelay: `${i * 0.4}s`,
      animationDuration: '3.5s'
    }} data-id="element-38" />)}

      {/* Orbit ring */}
      <ellipse cx="300" cy="470" rx="180" ry="60" stroke="#f8a400" strokeOpacity="0.25" strokeWidth="1.5" strokeDasharray="6 8" data-id="element-39" />

      {/* Planet */}
      <g data-id="element-40">
        <circle cx="320" cy="500" r="140" fill="#231ce5" fillOpacity="0.35" data-id="element-41" />
        <circle cx="320" cy="500" r="120" fill="#525aff" fillOpacity="0.9" data-id="element-42" />
        <circle cx="320" cy="500" r="120" fill="#080852" fillOpacity="0.55" data-id="element-43" />
        {/* craters */}
        <circle cx="280" cy="460" r="22" fill="#080852" fillOpacity="0.4" data-id="element-44" />
        <circle cx="360" cy="500" r="14" fill="#080852" fillOpacity="0.35" data-id="element-45" />
        <circle cx="300" cy="540" r="10" fill="#080852" fillOpacity="0.3" data-id="element-46" />
      </g>

      {/* Tether line from top */}
      <path d="M 250 -20 C 260 120, 210 220, 235 320" stroke="#f8a400" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.7" data-id="element-47" />

      {/* Astronaut (floating) */}
      <g className="rewayz-float" style={{
      transformOrigin: '235px 340px'
    }} data-id="element-48">
        {/* backpack */}
        <rect x="205" y="315" width="28" height="42" rx="10" fill="#e8ecff" data-id="element-49" />
        {/* body */}
        <rect x="218" y="312" width="42" height="60" rx="20" fill="#ffffff" data-id="element-50" />
        {/* left arm */}
        <rect x="200" y="322" width="34" height="16" rx="8" fill="#ffffff" transform="rotate(-24 217 330)" data-id="element-51" />
        {/* right arm */}
        <rect x="248" y="320" width="34" height="16" rx="8" fill="#ffffff" transform="rotate(28 265 328)" data-id="element-52" />
        {/* left leg */}
        <rect x="222" y="360" width="16" height="38" rx="8" fill="#ffffff" transform="rotate(-12 230 379)" data-id="element-53" />
        {/* right leg */}
        <rect x="242" y="360" width="16" height="38" rx="8" fill="#ffffff" transform="rotate(20 250 379)" data-id="element-54" />
        {/* boots */}
        <rect x="216" y="392" width="20" height="12" rx="5" fill="#f8a400" transform="rotate(-12 226 398)" data-id="element-55" />
        <rect x="250" y="392" width="20" height="12" rx="5" fill="#f8a400" transform="rotate(20 260 398)" data-id="element-56" />
        {/* chest control */}
        <circle cx="239" cy="340" r="5" fill="#f8a400" data-id="element-57" />
        {/* helmet */}
        <circle cx="239" cy="300" r="26" fill="#ffffff" data-id="element-58" />
        <circle cx="239" cy="300" r="19" fill="#080852" data-id="element-59" />
        <circle cx="239" cy="300" r="19" fill="#231ce5" fillOpacity="0.6" data-id="element-60" />
        {/* visor glare */}
        <ellipse cx="232" cy="293" rx="6" ry="9" fill="#ffffff" opacity="0.5" transform="rotate(-20 232 293)" data-id="element-61" />
      </g>
    </svg>;
}